import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import { useFetchApi } from "../../hooks/useFetchApi";
import TextField from "../../components/TextField";

const BulkUploadModal: React.FC<{
  status: boolean;
  onClose: any;
  onSuccess?: any;
  data?: any;
}> = ({ status, onClose, onSuccess, data = {} }): React.ReactElement => {
  const [d, setD] = useState<any>({});
  const { execute } = useFetchApi(
    "/api/bulk-upload/company-quarter",
    {},
    "POST",
    onSuccess
  );

  const handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.files;
    if (value.length) {
      setD({ ...d, [id]: value[0] });
    }
  };

  const handleOnSubmit = (e: any) => {
    const formData = new FormData();
    formData.append("file", d.file);
    execute(formData, { "Content-Type": "multipart/form-data" });
    const _e = { ...e, target: { ...e.target, id: "bulkUpload" } };
    onClose(_e);
  };

  const handleClose = (e: any) => {
    const _e = { ...e, target: { ...e.target, id: "bulkUpload" } };
    onClose(_e);
  };

  useEffect(() => {
    if (data && Object.keys(data).length) {
      setD(data);
    }

    return () => {
      setD({});
    };
  }, [data]);

  return (
    <Modal
      heading="Bulk Upload Company Quarter"
      status={status}
      onClose={handleClose}
      onSubmit={handleOnSubmit}
    >
      <TextField
        className="md:w-full h-auto border"
        id="file"
        type="file"
        onChange={handleChange}
      />
    </Modal>
  );
};

export default BulkUploadModal;
